<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      :class="this.$store.state.isRTL ? '' : ' me-sm-6'"
    >
      <li class="text-sm breadcrumb-item" :class="textWhite">
        <router-link
            v-if="this.$store.state.isRTL"
            :class="textWhite"
            class="opacity-5 ps-2"
            :to="{ name: 'Dashboard' }"
        >
          لوحات القيادة
        </router-link>
        <router-link
            v-else
            :class="textWhite"
            class="opacity-8"
            :to="{ name: 'Dashboard' }"
        >
          Dashboard
        </router-link>
      </li>
      <li
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="index"
        class="text-sm breadcrumb-item active"
        :class="textWhite ? 'text-white' : 'text-dark'"
        aria-current="page"
      >
      <router-link :to="getLink(breadcrumb)">
        {{ breadcrumb.title }}
      </router-link>
      </li>
    </ol>
    <!-- <h6 class="mb-0 font-weight-bolder" :class="textWhite ? 'text-white' : ''">
      {{ currentRouteName }}
    </h6> -->
  </nav>
</template>

<script>

export default {
  name: "breadcrumbs",
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
      required: true,
    },
    textWhite: {
      type: String,
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    getLink(breadcrumb) {
      // Se l'elemento breadcrumb ha name e params, usa il router-link dinamico
      if (breadcrumb.name) {
        return {
          name: breadcrumb.name,
          params: breadcrumb.params,
        };
      }
      // Altrimenti, usa il link statico
      return breadcrumb.link;
    },
  },
};
</script>
